// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.v-contact .v-contact-value { flex-grow: 1; }`, "",{"version":3,"sources":["webpack://./src/app/components/v-contact/v-contact.component.ts"],"names":[],"mappings":"AAAA,8BAA8B,YAAY,EAAE","sourcesContent":[".v-contact .v-contact-value { flex-grow: 1; }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
